<span id="header" class="display-flex" [ngClass]="useSloa ? 'not-active' : 'active'">Recipient</span>
<div class="checkboxGroup">
    <mm-radio-control [parentForm]="parentForm" [radioModel]="recipientModel"></mm-radio-control>
</div>
<div *ngIf="showEscrowOrTitleCompanyCheckbox" class="checkboxGroup" [formGroup]="parentForm">
    <input type="checkbox" formControlName="isEscrow" id="isEscrow" name="isEscrow" value="isEscrow"
        data-testid="wireRecipientInterimEscrowCheckbox">
    <label for="isEscrow">Recipient is an escrow/title company</label>
</div>
<mm-banners *ngIf="isEscrow$ | async" [bannerText]="[warningDescription]" [titleText]="warningTitle" [type]="'warning'"
    data-testid="wireRecipientInterimEscrowWarning"></mm-banners>
